import { Inject, Injectable } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { APP_CART_ROUTE, APP_CHECKOUT_ROUTE } from '~shared/constants';
import { Observable, of } from 'rxjs';

@Injectable()
export class CartNavigatorService {
  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {}

  navigateToCart(): Observable<boolean> {
    window.location.href = `/${this.baseHref.replace(new RegExp('/', 'g'), '')}/${APP_CHECKOUT_ROUTE}/${APP_CART_ROUTE}`;
    return of(true);
  }
}
